import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row content-wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Disponível para TODOS ")
const _hoisted_3 = { class: "row my-2" }
const _hoisted_4 = { class: "flex xs12 md6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "display-3 ml-2" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "display-6 ml-2" }
const _hoisted_9 = { class: "flex xs2 md1 px-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Máximo de códigos")
const _hoisted_11 = { class: "flex xs2 md1 px-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Códigos gerados")
const _hoisted_13 = { class: "flex xs2 md1 px-1" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Códigos usados")
const _hoisted_15 = { class: "flex xs2 md2 px-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Resultados permitidos ")
const _hoisted_17 = {
  class: "row",
  style: {"min-height":"15%"}
}

import { Scalars, Voucher, VoucherSearchInput } from "@/codes/gen/types";
import { VoucherService } from "@/codes/services/VoucherService";
import { ReactiveData } from "@/codes/types/MDOTypes";
import { DEFAULT_ITEMS_PER_PAGE, ROUTE_NAMES, VUEX_ACTIONS } from "@/codes/util/constants";
import { calculatePageCount, hasWritePermission } from "@/codes/util/functions";
import { Confirm } from "@/codes/util/swalUtil";
import router from "@/router";
import store from "@/store";
import moment from "moment";
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingVouchers = ref(false);
let page = 1;
const pageCount = ref(1);
const itemsPerPage = ref(DEFAULT_ITEMS_PER_PAGE);
const vouchers = reactive<ReactiveData<Voucher[]>>({ data: [] as Voucher[] });

const voucherDetail = reactive<ReactiveData<Voucher>>({ data: {} as Voucher });
const codes = reactive({ data: [] as any });
const isLoadingDetails = ref(false);
const showDetails = ref(false);

let pageLoaded = 0;

const i18n = useI18n();

const headers = reactive({ data: [
  { key: 'name', label: i18n.t('register.name') },
  { key: 'outsideBooks', label: 'Qr Codes'},
  { key: 'discountLabel', label: i18n.t('voucher.discountType'), width: 75 },
  { key: 'maxCodes', label: i18n.t('voucher.maxCodes'), width: 75 },
  { key: 'expiredAt', label: i18n.t('voucher.expiredAt'), width: 100 },
]});

const headersCodes = reactive({ data: [
  { key: 'code', label: i18n.t('voucher.codes.code'), width: 60 },
  { key: 'status', label: i18n.t('voucher.status'), width: 30 },
  { key: 'usedAt', label: i18n.t('voucher.usedAt'), width: 40 },
  { key: 'examType', label: i18n.t('voucher.exam.type'), width: 50 },

  { key: 'examAgentName', label: i18n.t('agent.title'), width: 100 },
  { key: 'examCampaignName', label: i18n.t('campaign.title'), width: 100 },
  { key: 'examClientName', label: i18n.t('client.title'), width: 100 },
  { key: 'examClientWhatsapp', label: i18n.t('register.whatsapp'), width: 75 },
]})

const checkHasWritePermission = function() {
  if (hasWritePermission(ROUTE_NAMES.vouchers)) {
    headers.data.push({ key: 'actions', label: i18n.t('form.actions'), width: 125 });
  }
}

const getFormattedDate = function(date: Scalars['Date']) {
  return moment(date.iso.toString()).format("DD/MM/yyyy");
}

const loadVouchers = async function() {
  vouchers.data = [];
  loadingVouchers.value = true;
  const service = new VoucherService();
  const search: VoucherSearchInput = { page: page, perPage: itemsPerPage.value };
  const vouchersEdge = await service.getAll(search);
  if (vouchersEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, vouchersEdge.pagination?.total ?? 1);
    vouchers.data = vouchersEdge.edges;
    pageLoaded = page;
  }
  loadingVouchers.value = false;
}

const onPageChanged = function(newPage: number) {
  page = newPage;
  loadVouchers();
}

onMounted(() => {
  loadVouchers();

  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        checkHasWritePermission();
      }
    }
  });

  checkHasWritePermission();
});

const doNew = function() {
  router.push({ name: ROUTE_NAMES.newVoucher });
};

const edit = function(id: string) {
  router.push({ name: ROUTE_NAMES.editVoucher, params: { id: id }});
}

const doRemove = async function(id: string) {
  const service = new VoucherService();
  const result = await service.remove(id);
  if (result && result.data.id) {
    vouchers.data = vouchers.data.filter((v) => v.id !== result.data.id);
    if (vouchers.data.length === 0) {
      if (page > 1) {
        onPageChanged(1);
      } else {
        window.location.reload();
      }
    }
  }
}

function remove(voucher: Voucher) {
  Confirm.fire({
    title: i18n.t('form.confirmDeleteTitle'),
    text: i18n.t('form.confirmDeleteMessage', { register: i18n.t('voucher.describe', { voucher: voucher.name }) })
  })
  .then((result) => {
    if (result.isConfirmed) {
      doRemove(voucher.id);
    }
  })
}

function closeDetails() {
  showDetails.value = false;
  voucherDetail.data = {} as Voucher;
}

async function detail(idVoucher: string) {
  showDetails.value = true;
  isLoadingDetails.value = true;
  const service = new VoucherService();
  const result = await service.detail(idVoucher);
  if (result) {
    voucherDetail.data = result;
    result.codes.forEach(code => {
      codes.data.push({
        code: code.code.split('-')[2],
        status: code.usedAt ? 'usado' : 'disponível',
        usedAt: code.usedAt?.transform|| '',
        examType: i18n.t(`enums.${code.exam?.type}`),
        examAgentName: code.exam?.agent.name,
        examCampaignName: code.exam?.campaign.name,
        examClientName: code.exam?.client.name,
        examClientWhatsapp: code.exam?.client.whatsapp
      })
    });
  }
  isLoadingDetails.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_base_list = _resolveComponent("base-list")!
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_navbar = _resolveComponent("va-navbar")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_base_list, {
        page: _unref(page),
        "page-count": pageCount.value,
        "current-route": _unref(ROUTE_NAMES).vouchers,
        "page-loaded": _unref(pageLoaded),
        "show-delete": false,
        onPageChanged: onPageChanged,
        onDoNew: doNew
      }, {
        default: _withCtx(() => [
          _createVNode(_component_va_data_table, {
            items: _unref(vouchers).data,
            columns: _unref(headers).data,
            "sticky-header": "",
            loading: loadingVouchers.value,
            "no-data-html": "Sem resultados",
            style: _normalizeStyle({
          '--va-data-table-scroll-table-color': 'var(--va-divider)',
        })
          }, {
            "cell(actions)": _withCtx(({ rowData }) => [
              _createVNode(_component_va_button, {
                icon: "fas fa-eye",
                class: "mr-2",
                color: "info",
                size: "small",
                onClick: ($event: any) => (detail(rowData.id))
              }, null, 8, ["onClick"]),
              _createVNode(_component_va_button, {
                icon: "fas fa-edit",
                class: "mr-2",
                color: "info",
                size: "small",
                onClick: ($event: any) => (edit(rowData.id))
              }, null, 8, ["onClick"]),
              _createVNode(_component_va_button, {
                icon: "fas fa-trash",
                size: "small",
                class: "danger",
                onClick: ($event: any) => (remove(rowData))
              }, null, 8, ["onClick"])
            ]),
            "cell(outsideBooks)": _withCtx(({ rowData }) => [
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowData.outsideBooks, (item) => {
                  return (_openBlock(), _createBlock(_component_va_chip, {
                    key: item,
                    outline: "",
                    class: "mr-1",
                    color: "info",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (rowData.outsideBooks.length === 0)
                  ? (_openBlock(), _createBlock(_component_va_chip, {
                      key: 0,
                      outline: "",
                      class: "mr-1",
                      color: "success",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            "cell(expiredAt)": _withCtx(({ rowData }) => [
              _createTextVNode(_toDisplayString(getFormattedDate(rowData.expiredAt)), 1)
            ]),
            _: 1
          }, 8, ["items", "columns", "loading", "style"])
        ]),
        _: 1
      }, 8, ["page", "page-count", "current-route", "page-loaded"])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: showDetails.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (showDetails.value = $event)),
      blur: "",
      "no-dismiss": "",
      "no-padding": "",
      size: "large",
      "hide-default-actions": "",
      "fixed-layout": "",
      class: "mdo"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_va_navbar, {
          color: "info",
          shape: "",
          class: "mb-2"
        }, {
          left: _withCtx(() => [
            _createVNode(_component_va_navbar_item, null, {
              default: _withCtx(() => [
                _createElementVNode("h3", {
                  class: "display-3",
                  style: _normalizeStyle({
                'color': 'var(--va-white)',
              })
                }, _toDisplayString(_ctx.$t('voucher.details')), 5)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(voucherDetail).data.name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h6", _hoisted_8, _toDisplayString(_unref(voucherDetail).data.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, { class: "pb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(voucherDetail).data.maxCodes), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, { class: "pb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(voucherDetail).data.qtDrawn), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_va_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, { class: "pb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(voucherDetail).data.qtUsed), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_va_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, { class: "pb-2" }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, {
                  class: "pb-2",
                  style: {"margin-top":"-1px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(voucherDetail).data.allowedResults, (item) => {
                      return (_openBlock(), _createBlock(_component_va_chip, {
                        key: item,
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`enums.${item}`)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_va_inner_loading, { loading: isLoadingDetails.value }, {
          default: _withCtx(() => [
            _createVNode(_component_va_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_content, { class: "pa-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_va_data_table, {
                        items: _unref(codes).data,
                        columns: _unref(headersCodes).data,
                        "no-data-html": "Sem resultados",
                        "sticky-header": "",
                        style: _normalizeStyle({
                  '--va-data-table-scroll-table-color': 'var(--va-divider)',
                })
                      }, null, 8, ["items", "columns", "style"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_va_button, { onClick: closeDetails }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('form.ok')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})